const Shape = Object.freeze({
  SQUARE: 'square',
  CIRCLE: 'circle',
});

export default Shape;
